export const intro = {
    "title": "Introduction",
    "content": "<p>Greetings!</p><p>My name is <strong>Christine Kefalianou</strong>, and I am a dedicated <strong>Full-Stack Engineer</strong> with a degree in Informatics Engineering.</p><p>I enjoy <strong>Full-Stack Engineering</strong> because it combines both front-end creativity with back-end challenges, allowing me to leverage my technical expertise and creative problem-solving skills.</p><p>Throughout this professional journey, I have seen firsthand how vital clear <strong>communication</strong> and strong <strong>organizational skills</strong> are to a project's success. Working in dynamic environments, has taught me that great software is rarely built in isolation, making <strong>collaboration</strong> one of the most rewarding aspects of my field.</p><p class='heroTagline'>I am passionate about <strong>continuous learning</strong> and staying updated with the latest technologies, which is why I persue various <strong>seminars</strong>, from time to time, to enhance my skills.</p><p>My technical proficiency includes <strong>Laravel</strong>, <strong>VueJS</strong>, and <strong>PostgreSQL</strong>, enabling me to build robust and scalable web applications.</p><p>I am excited about the opportunity to contribute my skills and expertise to innovative projects, and I look forward to collaborating with like-minded professionals in the field of Full-Stack Engineering.</p>",
};

export const details = {
    "title" : "a little more about me....",
    "list": [
        {
            "title": "Bachelor:",
            "content": "Informatics Engineering A.T.E.I. of Central Greece",
            "degree": "Diploma Degree: 7.43"
        },
        {
            "title": "Thesis:",
            "content": "Image Recognition & Classification using SVM",
            "degree": "Thesis Degree: 10",
            "link": "https://ckefalianou.gr/projects/thesis.pdf",
            "linkText": "Download Thesis"
        },
        {
            "title": "Languages:",
            "content": "English: Pearson PTE-LCCI (C2)</br>German: Goethe-Zertifikat (B1)"
        },
        {
            "title": "Driving Licence",
            "content": "B"
        }
    ]
};